import Modal from '@/components/Modals/Modal';

type Props = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isLoading?: boolean;
  onSuccess: () => void;
};

export default function BulkEditWarningModal({
  isOpen,
  setIsOpen,
  isLoading,
  onSuccess,
}: Props) {
  return (
    <Modal
      dialogTitle="Warning: This action will overwrite profile information"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      successButtonText="Continue"
      onSuccess={onSuccess}
      isLoading={isLoading}
    >
      <div className="text-sm text-gray-600 font-normal pt-3">
        Editing any fields here will replace the existing information on the
        selected profiles.
        <br />
        <br />
        Any new social links (excluding personal links already on the profiles),
        files, and contact details you will add be pushed to all selected
        profiles, replacing the existing data.
        <br />
        <br />
        Only the fields you edit will be updated. All untouched fields will
        remain unchanged.
      </div>
    </Modal>
  );
}
